/* eslint-disable @typescript-eslint/no-unused-vars */
import { FunctionComponent, ReactElement, useContext, useRef } from 'react';
import {
  BaseInput,
  BirthNameRules,
  FirstNameRules,
  GenderInput,
  GenderInputDS,
  LastNameRules,
  SelectedButton,
} from '../../components/DesignSystem';
import { Gender } from '../../store/constants';
import { store } from '../../store/store';
import { updateStore } from '../../store/store.actions';
import { ValidityHtmlElement } from '../../utils/DsType';
const Identite: FunctionComponent<Record<string, never>> = (): ReactElement => {
  const situationRef = useRef<GenderInputDS>(null);
  const civilityRef = useRef<GenderInputDS>(null);
  const {
    state: { holder },
    dispatch,
    apiStatus,
  } = useContext(store);

  // Fetch Maritals Data
  // const { response: maritals } = useFetch(() => apiClient().referential.getMaritals());

  // Add event listener for Maritals change value
  // useEffect(() => {
  //   if (!!situationRef && situationRef.current !== null) {
  //     situationRef.current.value = identity?.maritalStatusCode || '';
  //   }
  // }, [apiStatus]);
  // on Gender change
  const onGenderChange = (e: Event & { currentTarget?: { value?: unknown } | null }) => {
    if (!!civilityRef && civilityRef.current !== null) {
      (civilityRef.current as unknown as ValidityHtmlElement).assignValidity();
      dispatch(updateStore({ holder: { identity: { civility: e.currentTarget?.value } } }));
    }
  };
  // on firstname change
  const onFirstNameChange = (e: Event & { currentTarget?: { value?: unknown } | null }) => {
    dispatch(updateStore({ holder: { identity: { firstname: e.currentTarget?.value } } }));
  };
  // on Name change
  const onLastNameChange = (e: Event & { currentTarget?: { value?: unknown } | null }) => {
    dispatch(updateStore({ holder: { identity: { lastname: e.currentTarget?.value } } }));
  };
  // on birthName change
  const onBirthNameChange = (e: Event & { currentTarget?: { value?: unknown } | null }) => {
    dispatch(updateStore({ holder: { identity: { birthName: e.currentTarget?.value } } }));
  };
  // on situation change
  const onSituationChange = (e: Event & { currentTarget?: { value?: unknown } | null }) => {
    if (!!situationRef && situationRef.current !== null) {
      (situationRef.current as unknown as ValidityHtmlElement).assignValidity();
      dispatch(updateStore({ holder: { identity: { maritalStatusCode: e.currentTarget?.value } } }));
    }
  };
  return (
    <>
      <GenderInput
        ref={civilityRef}
        class="to-validate trackable-click"
        label="Civilité"
        data-id="civility"
        onSelectedElementChange={onGenderChange}
        value={holder?.identity?.civility}
        error-message="Veuillez choisir Madame ou Monsieur."
      >
        <SelectedButton value={Gender.MAN} secondary>
          Monsieur
        </SelectedButton>
        <SelectedButton value={Gender.WOMAN} secondary>
          Madame
        </SelectedButton>
      </GenderInput>
      <BaseInput
        class="to-validate trackable-blur"
        required
        label="Prénom"
        data-id="firstname"
        maxLength="30"
        onInputChange={onFirstNameChange}
        onLetterChanged={onFirstNameChange}
        value={holder?.identity?.firstname}
        replacement={FirstNameRules.replacement}
        customValidityPattern={FirstNameRules.customValidityPattern}
        error-message="Veuillez renseigner votre prénom."
      ></BaseInput>
      <BaseInput
        class="to-validate trackable-blur"
        onInputChange={onLastNameChange}
        onLetterChanged={onLastNameChange}
        required
        label="Nom"
        data-id="lastname"
        maxLength="30"
        value={holder?.identity?.lastname}
        replacement={LastNameRules.replacement}
        customValidityPattern={LastNameRules.customValidityPattern}
        error-message="Veuillez renseigner votre nom."
      ></BaseInput>
      <BaseInput
        onInputChange={onBirthNameChange}
        onLetterChanged={onBirthNameChange}
        class="to-validate trackable-blur"
        label="Nom de naissance (si différent du nom)"
        data-id="birthName"
        maxLength="30"
        value={holder?.identity?.birthName}
        replacement={BirthNameRules.replacement}
      ></BaseInput>

      {/* <GenderInput
        ref={situationRef}
        class="to-validate trackable-click"
        label="Situation familiale"
        data-id="maritalStatusCode"
        onSelectedElementChange={onSituationChange}
        value={identity?.maritalStatusCode}
        error-message="Veuillez choisir votre situation familiale."
      >
        {maritals &&
          maritals.map(({ id, label }: Marital) => (
            <SelectedButton key={id} value={id} secondary>
              {label}
            </SelectedButton>
          ))}
      </GenderInput> */}
    </>
  );
};

export default Identite;
